export const useSetersToMap = () => {
	const getForeignObject = (
		element: any,
		value: string,
		fontColor: string,
		fontSize: any,
		textAlign: string,
	) => {
		const foreignObject = document.createElementNS(
			"http://www.w3.org/2000/svg",
			"foreignObject",
		);
		const div = document.createElement("div");
		const text = document.createTextNode(value);

		div.style.textAlign = textAlign;
		div.style.color = fontColor;
		div.appendChild(text);

		const className = element.getAttribute("class");
		const width = element.getAttribute("width");
		const height = element.getAttribute("height");
		const x = element.getAttribute("x");
		const y = element.getAttribute("y");
		const transform = element.getAttribute("transform");

		if (className === "r3") {
			div.title = "Close Orders";
		}
		if (className === "r4") {
			div.title = "PM Open Order";
		}
		if (className === "r5") {
			div.title = "RM Open Orders";
		}

		foreignObject.setAttribute("width", width);
		foreignObject.setAttribute("height", height);
		foreignObject.setAttribute("x", x);
		foreignObject.setAttribute("y", y);
		if (fontSize) foreignObject.setAttribute("font-size", fontSize);
		if (transform) foreignObject.setAttribute("transform", transform);

		foreignObject.appendChild(div);

		return foreignObject;
	};

	const setArrowColorAndInfo = (mainContainer: any) => {
		const arrow = document.getElementsByClassName("arrow");
		const text = document.getElementsByClassName("arrow-text");

		if (arrow && arrow[0]) {
			arrow[0].setAttribute("style", "fill:red");
		}

		if (arrow && arrow[1]) {
			arrow[1].setAttribute("style", "fill:red");
		}
		if (text && text[0]) {
			const arrowRect = text[0];
			const foreignObject = getForeignObject(
				arrowRect,
				"Casting Direction",
				"black",
				null,
				"center",
			);
			mainContainer.appendChild(foreignObject);
		}
	};

	return { setArrowColorAndInfo, getForeignObject };
};
